import type { SMLRootParamList, SMLRouteNames } from '../../../routing/sml/SMLRoutes';

type StudioParams = NonNullable<SMLRootParamList[SMLRouteNames.promoteStudio]>;

/**
 * The Studio params that open the AI reel theme (a Short video). `reel` opens that reel's page,
 * `catalogItemUuid` opens the form on that song.
 */
export function aiReelStudioParams(params: { catalogItemUuid?: string; reel?: string } = {}): StudioParams {
  return { ...params, format: 'short', theme: 'aiReel' };
}

/**
 * The Studio query for an old link (spec D28). `promote/promoteReels` opens the AI reel theme with
 * the same `catalogItemUuid` and `reel`. `promote/promoteClips` opens the Short format with no
 * theme (owner ruling, review M13): the user picks the theme. Every other parameter (for example
 * `accountId`, `catalogItemUuid`) stays.
 */
export function legacyStudioSearch(search: string, from: 'reels' | 'clips'): string {
  const params = new URLSearchParams(search);
  params.set('format', 'short');
  if (from === 'reels') {
    params.set('theme', 'aiReel');
  } else {
    params.delete('theme');
  }
  const query = params.toString();
  return query === '' ? '' : `?${query}`;
}
